export class ArbetsorderMaskinlagTexts {
// eslint-disable-next-line sonarjs/public-static-readonly
    static texts = {
        skordningStart: "Skördaroperation (start-slut)",
        skotningStart: "Skotaroperation (start-slut)",
        valjMaskinlag: "Välj maskinlag",
        skotningsavstand: "Skotningsavstånd",
        antalDagarTotalt: "Antal dagar totalt",
        varavArbetsdagar: "Varav arbetsdagar",
        arbetstimmarPerDag: "Arbetstimmar/dag",
        skordadPrestationPerDag: "Skördarprestation m3f/dag",
        maskinregister: "Maskinregister",
        justerad: "Justerad",
        avrundad: "Avrundad",
        utfallPerArbetsdag: "Utfall",
        korrektion: "Korrektion",
        lankTillMaskinregister: "Länk till maskinregister",
        fomaInfo: "Det kan ta tid innan eventuella ändringar i maskinregistret syns i Rask.",
        totaltUtfall: "Skördad volym",
        planeradVolym: "Planerad volym",
        utfallPerPlanerad: "Andel skördat",
        fordrojningSkotning: "Fördröjning skotning dagar",
        minaMaskinlag: "Mina maskinlag",
        findNextAvailableSpaceInSchedule: "Hitta första lediga tid",
        valjEntreprenor: "Välj entreprenör",
        entreprenorSaknas: "Entreprenör saknas på maskin i maskinregistret."
    };
}
